import {PageLayout, FirmsAdvancedTable, Filters} from '~/components'
import {SearchPageHeader} from '../search_header'
import {useHandleSearch, useSearchPlaceholderProps} from '../hooks'
import {useHasRequiredRecords} from '~/hooks'
import {useMemo} from 'react'
import utils from '@eitje/utils'
import {Placeholder} from '~/components'
import {BillingInfo, Organisation, Environment} from '@eitje/api'

export const SearchFirm = () => {
	const hasRequiredRecords = useHasRequiredRecords(['environments', 'organisations', 'billingInfos'])

	const billingInfos = BillingInfo.useAll({joins: ['environments', 'organisations']})
	const organisations = Organisation.useAll({joins: ['environments', 'billingInfos']})
	const environments = Environment.useAll({joins: ['organisations', 'billingInfos']})

	const items = useMemo(() => [...environments, ...organisations, ...billingInfos], [environments, organisations, billingInfos])

	const {handleChange, handleKeyDown, handleClear, searchValue, searchQuery} = useHandleSearch('firm')

	const searchResults = useMemo(() => {
		return searchQuery ? utils.search(items, searchQuery, {field: ['id', 'name', 'naam', 'company_name']}) : []
	}, [searchQuery, items])

	const placeholderProps = useSearchPlaceholderProps({searchResults, searchQuery, isLoading: !hasRequiredRecords})

	return (
		<PageLayout
			name="firm"
			headers={[
				<SearchPageHeader
					key={0}
					headerLabel="common.firms"
					searchDropdownProps={{triggerText: 'common.firms'}}
					searchInputProps={{searchValue, handleChange, handleKeyDown, handleClear}}
					searchExplanationPopoutProps={{title: 'firm.search', body: 'firm.popout.body'}}
				/>,
				searchQuery && <Filters key={1} />,
			]}
			filterProps={{items: searchResults, filters: ['firmType']}}
		>
			{placeholderProps ? <Placeholder {...placeholderProps} /> : <FirmsAdvancedTable />}
		</PageLayout>
	)
}
